import { useState, useCallback } from 'react';
import { LobbyScreen } from './client/components/screens/LobbyScreen';
import { GameScreen } from './client/components/screens/GameScreen';
import { BotGameScreen } from './client/components/screens/BotGameScreen';
import { useDiscord } from './client/context/DiscordContext';

type AppMode = 'lobby' | 'playing' | 'bot';

function App() {
  const { isLoading, error, roomId, isInitialized } = useDiscord();
  const [mode, setMode] = useState<AppMode>('lobby');

  const handleGameStart = useCallback(() => {
    setMode('playing');
  }, []);

  const handlePlayBot = useCallback(() => {
    setMode('bot');
  }, []);

  const handleBackToLobby = useCallback(() => {
    setMode('lobby');
  }, []);

  // Show loading while Discord SDK initializes
  if (isLoading) {
    return (
      <div className="app loading-screen">
        <div className="loading-content">
          <h1 className="gold-gradient">Alchemy Duel</h1>
          <p>Connecting to Discord...</p>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  // Show error if initialization failed
  if (error && !isInitialized) {
    return (
      <div className="app error-screen">
        <div className="error-content">
          <h1 className="gold-gradient">Alchemy Duel</h1>
          <p className="error-message">Failed to connect: {error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      {mode === 'lobby' && (
        <LobbyScreen
          roomId={roomId}
          onGameStart={handleGameStart}
          onPlayBot={handlePlayBot}
        />
      )}

      {mode === 'playing' && (
        <GameScreen
          roomId={roomId}
          onBackToLobby={handleBackToLobby}
        />
      )}

      {mode === 'bot' && (
        <BotGameScreen
          onBackToLobby={handleBackToLobby}
        />
      )}
    </div>
  );
}

export default App;
